import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const filtros = {
	state: {
		filtros : {
			candidaturas : {
				estado : [],
				text : '',
				type : '',
			},
			ofertas : {
				comun : {},
				date : 0,
				text : {
					titulo : '',
					provincia : '',
					titulaciones : '',
					empresa: '',
					sector: ''
				},
				omitirInscritos : false,
				fechainicio : '',
			},
			misofertas : {
				estado : [],
				date : 0,
				titulo :'',
				type : [],
				omitirLeidos : false,
				caducanPronto : false,
				soloConCandidatos : false
			},
			recursos : {
				categorias : []
			}
		}
	},
	getters: {
		getfiltroscandidaturas : state => state.filtros.candidaturas,   
		getfiltrosofertas : state => state.filtros.ofertas,   
		getfiltrosmisofertas : state => state.filtros.misofertas,   
		getfiltrosrecursos : state => state.filtros.recursos,   
	}, 
	actions: {
		requestSetFiltroCandidatura : function({commit}, data){
			commit('setfiltrosCandidaturas',data);
		},
		requestSetFiltroOfertas : function({commit}, data){
			commit('setfiltrosOfertas',data);
		},
		requestSetFiltroMisOfertas : function({commit}, data){
			commit('setfiltrosMisOfertas',data);
		},
		requestSetFiltroRecursos : function({commit}, data){
			commit('setfiltrosRecursos',data);
		}
	},
	mutations: {
		setfiltrosCandidaturas : function(state,data){
			state.filtros.candidaturas = data;
		},
		setfiltrosOfertas : function(state,data){
			state.filtros.ofertas = data;
		},
		setfiltrosMisOfertas : function(state,data){
			state.filtros.misofertas = data;
		},
		setfiltrosRecursos : function(state,data){
			state.filtros.recursos = data;
		}
	}
}

export default filtros;



// WEBPACK FOOTER //
// ./src/store/filtros.js